export default __webpack_public_path__ + "static/media/extra-address-purple-icon.019f1d88.svg";